module.exports = __webpack_public_path__ + "img/error02.a5c61a82.png";